import privacyPolicy from './privacyPolicy'

export default {
  namespaced: true,
  state: { privacyPolicy },
  getters: {
    privacyPolicy: state => state.privacyPolicy
  }
}
